import {
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
} from "@nextui-org/react";
import Skeleton from "../../Skeleton";

interface Props {
  numberOfColumns: number;
  numberOfRows: number;
}

const TableSkeleton = (props: Props) => {
  const { numberOfColumns, numberOfRows } = props;

  const columns = Array.from({ length: numberOfColumns }, (_, i) => ({
    key: `column-${i}`,
  }));
  const rows = Array.from({ length: numberOfRows }, (_, rowIndex) => ({
    key: `row-${rowIndex}`,
    cells: Array.from({ length: numberOfColumns }, (_, colIndex) => ({
      key: `cell-${rowIndex}-${colIndex}`,
    })),
  }));

  return (
    <Table aria-label="Table" removeWrapper>
      <TableHeader columns={columns}>
        {(column) => (
          <TableColumn
            key={column.key}
            className="bg-white border-b-1 border-primary-800 border-b-primary-800 p-2"
          >
            <Skeleton width="100%" height="28px" />
          </TableColumn>
        )}
      </TableHeader>
      <TableBody items={rows}>
        {(row) => (
          <TableRow
            key={row.key}
            className="border-b-1 border-secondary-500 border-b-secondary-500"
          >
            {row.cells.map((cell) => (
              <TableCell key={cell.key}>
                <Skeleton width="100%" height="52px" />
              </TableCell>
            ))}
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};

export default TableSkeleton;
